import { TagColor } from '@factorialco/deprecated-design-system'
import { BookkeepersManagementIncidencePayrollIntegrationStatus } from 'generated/resources/graphql'

export default function payrollIntegrationStatusTagColor(
  payrollIntegrationIncidenceStatus:
    | BookkeepersManagementIncidencePayrollIntegrationStatus
    | undefined
) {
  if (!payrollIntegrationIncidenceStatus) {
    return TagColor.grey
  }

  const TAG_COLORS: Record<string, TagColor> = {
    unavailable: TagColor.radical,
    available: TagColor.champagne,
    done: TagColor.lime,
  }

  return TAG_COLORS[payrollIntegrationIncidenceStatus.status] || TagColor.grey
}
